export function sanitizeFilterQuery(filters: object): Record<string, unknown> {
	return Object.fromEntries(
		Object.entries(filters).flatMap(([key, value]) => {
			const present = (item: unknown) =>
				item !== null &&
				item !== undefined &&
				(typeof item !== 'string' || Boolean(item.trim()));
			if (Array.isArray(value)) {
				const items = value.filter(present);
				return items.length ? [[key, items]] : [];
			}
			return present(value) ? [[key, value]] : [];
		})
	);
}
